var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticStyle:{"cursor":"pointer"},attrs:{"to":_vm.to,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"mr-4",attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.icon))]),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }